const getItemListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'rgba(0, 0, 0, 0.12)' : 'transparent',
  width: 118,
  height: 240,
  padding: 0,
  borderRadius: 4,
});

export default getItemListStyle;
